/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PF Appointments API
 * appointments-api v1. Generated from the route table; do not edit by hand (pnpm openapi).
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod'

export const publicConfigHoursItemEndRegExp = new RegExp('^([01]\\d|2[0-3]):[0-5]\\d$|^24:00$')
export const publicConfigHoursItemStartRegExp = new RegExp('^([01]\\d|2[0-3]):[0-5]\\d$|^24:00$')
export const publicConfigHoursItemWeekdayMin = 0
export const publicConfigHoursItemWeekdayMax = 6

export const publicConfigHoursMin = 7
export const publicConfigHoursMax = 7

export const PublicConfig = zod.object({
  bookingStatus: zod.enum(['available', 'pf_unavailable', 'clinic_inactive', 'nothing_bookable']),
  clinic: zod.object({
    branding: zod.object({
      accentColor: zod.string().nullable(),
      logoUrl: zod.string().nullable(),
    }),
    name: zod.string(),
    slug: zod.string(),
    timeZone: zod.string(),
  }),
  contact: zod.object({
    address: zod.string(),
    email: zod.string(),
    phone: zod.string(),
  }),
  holdMinutes: zod.literal(5),
  hours: zod
    .array(
      zod.object({
        end: zod.string().regex(publicConfigHoursItemEndRegExp),
        open: zod.boolean(),
        start: zod.string().regex(publicConfigHoursItemStartRegExp),
        weekday: zod.int().min(publicConfigHoursItemWeekdayMin).max(publicConfigHoursItemWeekdayMax),
      }),
    )
    .min(publicConfigHoursMin)
    .max(publicConfigHoursMax),
  reasonMaxLength: zod.literal(500),
  recaptcha: zod.object({
    checkboxSiteKey: zod.string(),
    scoreSiteKey: zod.string(),
  }),
})

export type PublicConfig = zod.input<typeof PublicConfig>
export type PublicConfigOutput = zod.output<typeof PublicConfig>
